import 'vuetify/styles'
import * as components from 'vuetify/components'
import { VBtn } from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fa } from 'vuetify/iconsets/fa-svg'
import * as labsComponents from 'vuetify/labs/components'
import { de, en, fr, it } from 'vuetify/locale'
import DateFnsAdapter from '@date-io/date-fns'
import { de as deFNS } from 'date-fns/locale/de'
import { enGB } from 'date-fns/locale/en-GB'
import { frCH as frFNS } from 'date-fns/locale/fr-CH'
import { itCH as itFNS } from 'date-fns/locale/it-CH'
import { config, themes } from '@deepcloud/deep-ui-lib'

const vuetifyConfig = config.createVuetifyConfig({
  directives,
  components: {
    ...components,
    ...labsComponents,
  },
  date: {
    adapter: DateFnsAdapter,
    locale: {
      en: enGB,
      de: deFNS,
      fr: frFNS,
      it: itFNS,
    },
  },
  locale: {
    messages: {
      de,
      en,
      fr,
      it,
    },
    locale: import.meta.env.VITE_I18N_LOCALE || 'de',
  },
  icons: {
    // TODO remove when DeepUiLib got updated
    sets: {
      fa,
    },
  },

  theme: {
    defaultTheme: 'light',
    variations: {
      colors: ['primary', 'secondary'],
      lighten: 2,
      darken: 0,
    },
    themes: {
      light: {
        ...themes.deepCloudLight,
        colors: {
          ...themes.deepSignLight.colors,
          ...themes.deepVLight.colors,
          ...themes.deepCloudLight.colors,
          'surface-light': '#fff',
        },
        variables: {},
      },
      dark: {
        ...themes.deepCloudDark,
        colors: {
          ...themes.deepSignDark.colors,
          ...themes.deepVDark.colors,
          ...themes.deepCloudDark.colors,
        },
        variables: {},
      },
    },
  },
  aliases: {
    VBtnIcon: VBtn,
  },
  defaults: {
    // Alias
    VBtnIcon: {
      variant: 'text',
      size: 'small',
    },
    // Vuetify Components
    VAvatar: {
      // https://github.com/vuetifyjs/vuetify/issues/20345
      border: 0,
    },
    VBtn: {
      variant: 'flat',
      color: undefined,
    },
    VIcon: {
      size: 18,
    },
    VDivider: {
      color: 'grey-lighten-2',
    },
    VMenu: {
      VCard: {
        class: 'rounded-lg',
      },
      VList: {
        rounded: 'lg',
      },
    },
    VTextField: {
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable',
    },
    VMaskInput: {
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable',
    },
    VTextarea: {
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      color: 'primary',
      itemColor: 'primary',
      density: 'comfortable',
    },
    VAutocomplete: {
      variant: 'outlined',
      color: 'primary',
      itemColor: 'primary',
      menuProps: {
        contentClass: 'rounded-lg',
      },
      density: 'comfortable',
    },
    VCombobox: {
      variant: 'outlined',
      color: 'primary',
      itemColor: 'primary',
      menuProps: {
        contentClass: 'rounded-lg',
      },
      density: 'comfortable',
    },
    VStepperItem: {
      editIcon: 'far fa-pencil',
    },
  },
})

console.log('vuetifyConfig =>  ', vuetifyConfig)

export default vuetifyConfig
